import { module } from 'modujs';
import KeenSlider from 'keen-slider'
import { lazyLoadImage } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
          click: {
              close: 'menuClose',
              openSecondary: 'openSecondPanel',
              closeSecondary: 'closeSecondPanel',
              loginClick: 'loginOpen',
              wishlistClick: 'wishlistOpen',
              searchClick: 'searchOpen',
              carouselLine: 'activeLine',
          }
        };

        this.secondaryPanel = null;
        this.keenInstance = null;

        this.fadeIn = this.el.animate([
          { background: "rgba(255,255,255,0)" },
          { background: "rgba(255,255,255,0.8)" },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.fadeIn.pause();

        this.slideIn = this.$('menu')[0].animate([
          { transform: "translate(-100%,0)" },
          { transform: "translate(0%,0)" },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.slideIn.pause();

        this.closeIn = this.$('close')[0].animate([
          { opacity: 0 },
          { opacity: 1 },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.closeIn.pause();

        this.menuOpened = false;
    }

    init() {
      const allAnchors = this.el.querySelectorAll("a");
      allAnchors.forEach((el) => {
        el.addEventListener("click", this.menuClose.bind(this))
      })
    }

    loginOpen(e) {
      this.call('menuOpen', null, 'Login');
      this.menuClose();
    }

    searchOpen(e) {
      this.call('menuOpen', null, 'Search');
      this.menuClose();
    }

    wishlistOpen(e) {
      this.call('menuOpen', null, 'Wishlist');
      this.menuClose();
    }

    menuToggle() {
      if(this.menuOpened) {
        this.menuClose()
      } else {
        this.menuOpen()
      }
    }

    activeLine(e) {
      const idx = this.getData('index', e.currentTarget) - 1;
      this.keenInstance.moveToIdx(idx)
    }

    updateClasses() {
      const slide = this.keenInstance.track.details.rel;

      Array.from(this.$('carousel-nav')[0].children).forEach(function (line, idx) {
        idx === slide
          ? line.classList.add("-active")
          : line.classList.remove("-active")
      })
    }

    loadImages() {
      let lazyImages = this.el.querySelectorAll('[data-lazyload]');
      lazyImages.forEach((el) => {
        lazyLoadImage(el, null, () => {
          //callback
        })
      })
    }

    menuOpen() {
      this.menuOpened = true;
      this.call('cartClose', null, 'Headerfloat');
      document.body.style.overflow = "hidden"
      this.el.style.display = "flex"
      this.fadeIn.playbackRate = 1;
      this.slideIn.playbackRate = 1;
      this.closeIn.playbackRate = 1;
      this.fadeIn.play();
      this.fadeIn.finished.then(() => {
        this.fadeIn.pause();
        this.loadImages();
      });

      this.slideIn.play();
      this.slideIn.finished.then(() => {
        this.slideIn.pause();
      });

      this.closeIn.play();
      this.closeIn.finished.then(() => {
        this.closeIn.pause();
      });

      this.keenInstance = new KeenSlider(this.$('carousel')[0], { loop: true, auto: true });
      this.keenInstance.on("slideChanged", () => {
        this.updateClasses()
      })
    }

    menuClose() {
      this.menuOpened = false;
      this.fadeIn.reverse();
      this.slideIn.reverse();
      this.closeIn.reverse();

      this.fadeIn.finished.then(() => {
        this.fadeIn.pause();
        this.slideIn.pause();
        this.closeIn.pause();
        document.body.style.overflow = "auto"
        this.el.style.display = "none"
        this.keenInstance.destroy();
        if(this.secondaryPanel) {
          this.closeSecondPanel();
        }
      })

      this.slideIn.finished.then(() => {
        this.slideIn.pause();
      });

      this.closeIn.finished.then(() => {
        this.closeIn.pause();
      });

    }

    openTopPanel(e) {
      this.$(`panel-top`)[0].style.display = "flex";
    }

    closeTopPanel(e) {
      this.$(`panel-top`)[0].style.display = "none";
    }

    closeSecondPanel(e) {
      this.openTopPanel();
      this.secondaryPanel.style.display = "none";
      this.secondaryPanel = null;
    }

    openSecondPanel(e) {
      this.closeTopPanel();
      const id = this.getData('id', e.currentTarget);
      this.secondaryPanel = this.$(`panel-${id}`)[0];
      this.secondaryPanel.style.display = "block";
    }
}
